<template>
    <div class="section hero-mini">
        <div class="bg-layers">
            <img src="@/assets/calculator/mini-home-image.png" alt="home-Layer" class="mini-layer">
        </div>

        <div class="container">
            <div class="content">
                <h2 class="white-text weight-med center-text">{{ msg }}</h2>
                <h4 class="light-text center-text">{{ subMsg }}</h4>
            </div>
        </div>

        <div class="back-option" v-on:click="$router.go(-1)">
<!-- svg icon start -->
          <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
          width="20" height="20"
          viewBox="0 0 224 224"
          style=" fill:#A59DC4;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,224v-224h224v224z" fill="none"></path><g fill="#A59DC4"><g id="surface1"><path d="M112,21c-50.17578,0 -91,40.82422 -91,91c0,50.17578 40.82422,91 91,91c50.17578,0 91,-40.82422 91,-91c0,-50.17578 -40.82422,-91 -91,-91zM112,35c42.60157,0 77,34.39844 77,77c0,42.60157 -34.39843,77 -77,77c-42.60156,0 -77,-34.39843 -77,-77c0,-42.60156 34.39844,-77 77,-77zM106.96875,67.15625l-44.84375,44.84375l44.84375,44.84375l10.0625,-9.84375l-28,-28h71.96875v-14h-71.96875l28,-28z"></path></g></g></g></svg>
<!-- svg icon end -->
          <p class="light-text disclaimer-body">Previous Page</p>
        </div>
    </div>
</template>

<script>
export default {
  name: "HeroMini",
  props: {
    msg: String,
    subMsg: String
  }
};
</script>

<style lang="scss">
@import "@/styles/global.scss";

.hero-mini {
  height: 480px;
  background-color: $dark-shade-2;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -ms-grid-row-align: center;
  align-items: center;
  @media only screen and (max-width: $tablet) {
    height: 60vh;
  }
}

.back-option {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-left: 24px;
  margin-top: 84px;
  cursor: pointer;

  @media only screen and (max-width: $tablet) {
    margin-top: 64px;
  }
  @media only screen and (max-width: $mobile) {
    margin-top: 55px;
    margin-left: 12px;

  }
}

.back-option p {
  margin-left: 6px;
}

.hero-mini h2 {
  margin-bottom: 16px;
}

.hero-mini .container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.hero-mini .content {
  margin-top: -55px;
  width: 64%;

  @media only screen and (max-width: $tablet) {
    width: 80%;
  }
}

.hero-mini .bg-layers {
  position: absolute;
  overflow: hidden;
  height: 500px;
  width: 100%;
  @media only screen and (max-width: $tablet) {
    height: 60vh;
  }
}

.hero-mini .mini-layer {
  position: absolute;
  -o-object-fit: cover;
  object-fit: cover;
  -o-object-position: center;
  object-position: center;
  width: 100%;
  height: auto;
  bottom: 0;
}
</style>
